/**
 * Portal Manta · importarExcelKpis
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import * as XLSX from 'xlsx';
import { extKm } from '../../globals.js';

function importarExcelKpis(arrayBuffer){
  if (typeof XLSX === 'undefined') return {ok:false, erro:'XLSX não disponível'};
  try {
    const wb = XLSX.read(arrayBuffer, {type:'array'});
    const ws = wb.Sheets[wb.SheetNames[0]];
    const rows = XLSX.utils.sheet_to_json(ws, {header:1, defval:null});
    // Procurar formato "chave | valor" nas 2 primeiras colunas
    const map = {};
    rows.forEach(r => {
      if (r[0] && r[1] !== null && r[1] !== undefined) {
        const k = String(r[0]).trim().toLowerCase();
        const v = parseFloat(String(r[1]).replace(',','.'));
        if (!isNaN(v)) map[k] = v;
      }
    });
    const get = (...keys) => {
      for (const k of keys) {
        for (const mk of Object.keys(map)) {
          if (mk.includes(k)) return map[mk];
        }
      }
      return 0;
    };
    return {ok:true, kpis:{
      extKm: get('extens', 'ext_km', 'km total'),
      dupKm: get('duplica'),
      margKm: get('margin'),
      fxKm: get('faixa'),
      ciclKm: get('ciclo'),
      oaeQt: get('oae'),
      passQt: get('passarel'),
      interQt: get('interse', 'interç'),
    }, preview: rows.slice(0,15)};
  } catch(e) {
    return {ok:false, erro:'Erro ao ler Excel: '+e.message};
  }
}

export { importarExcelKpis };
export default importarExcelKpis;
